import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import useGetProcessConfigurationStatus from 'modules/processes/hooks/useProcessSettiingsValidation'
import { useProcessContext } from 'modules/processes/pages/Process/ProcessRootPage'

export const AddEmployee = () => {
  const { process } = useProcessContext()
  const { navigation } = useNavigation()
  const { category, id } = useParams()
  const navigate = useNavigate()

  function handleClick() {
    navigate(
      navigation.processes.template.id.employees.new.fullPath({
        category: category as string,
        id: process.id,
      })
    )
  }

  const { processValidationData } = useGetProcessConfigurationStatus(process)
  const status = processValidationData?.validSettings
    ? null
    : processValidationData?.validationMessage

  return (
    <Button type="secondary" disabled={!!status} onClick={handleClick} iconName="add">
      {i18n.t('processes.process.employee.new')}
    </Button>
  )
}
